export function getToken() {
  return localStorage.getItem('astraToken');
}

export function getRole() {
  return localStorage.getItem('astraRole'); // 'super_admin' | 'curator'
}

export function setSession(token, role) {
  localStorage.setItem('astraToken', token);
  localStorage.setItem('astraRole', role);
}

export function logout() {
  localStorage.removeItem('astraToken');
  localStorage.removeItem('astraRole');
  window.location.href = '/login';
}
